module.exports = __webpack_public_path__ + "img/Chip Brown.991cb100.jpg";